/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export { getWebAutoInstrumentations } from './utils';
export type { InstrumentationConfigMap } from './utils';
